import * as React from 'react';

import type { AccountViewModel } from 'ab-viewModels/account.viewModel';

import Pill from 'af-components/Pills/Pill';
import Tooltip from 'af-components/Tooltip';

const renderPillItem = (item: AccountViewModel) => {
	return (
		<div>
			{item.firstName} {item.lastName} ({item.uniqueId})
		</div>
	);
};

interface OwnProps {
	onExcludeAccount: (index: number, accountId: number) => void;
	account: AccountViewModel;
	index: number;
	willReceiveNotification: boolean;
	hasEmail: boolean;
}

type Props = OwnProps;

const AccountItem: React.FC<Props> = (props) => {
	const {
		onExcludeAccount,
		index,
		account: { id: accountId },
		account,
		willReceiveNotification,
		hasEmail,
	} = props;

	const handleExcludeAccount = React.useCallback(() => {
		onExcludeAccount(index, accountId);
	}, [accountId, index, onExcludeAccount]);

	const body = (
		<Pill
			isTransparent={!willReceiveNotification}
			item={account}
			removeItem={handleExcludeAccount}
			renderItem={renderPillItem}
			skipConfirmationModal={true}
		/>
	);

	if (willReceiveNotification) {
		return body;
	}

	return (
		<Tooltip
			className="tooltip--center-text"
			message={`${account.fullName} won't be notified (missing ${!hasEmail ? 'email' : 'mobile phone'})`}
			placement="top"
		>
			<div>{body}</div>
		</Tooltip>
	);
};

export default React.memo(AccountItem);
